import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import type { FieldValues } from 'react-hook-form';

import { useGetAssessmentsRegister } from '@/hooks/queries';
import { getFriendlyId } from '@/utils/friendlyId';

import ControlledSelect from '../controlled-select';
import type { ControlledBaseProps } from '../types';

interface Props<T extends FieldValues> extends ControlledBaseProps<T> {
  addEmptyOption?: boolean;
  disabled?: boolean;
  testId: string;
  expandToViewport?: boolean;
}

export const ControlledAssessmentSelector = <T extends FieldValues>({
  ...props
}: Props<T>) => {
  // The factory hook already surfaces fetch errors through
  // useErrorNotification, so the manual onError toast is no longer needed.
  const { data, loading } = useGetAssessmentsRegister({ queryArgs: {} });

  const options =
    data?.assessment.map((assessment) => ({
      value: assessment.Id,
      label:
        assessment?.Title ??
        getFriendlyId(Parent_Type_Enum.Assessment, assessment.SequentialId),
    })) ?? [];

  return (
    <ControlledSelect
      statusType={loading ? 'loading' : 'finished'}
      options={options}
      {...props}
    />
  );
};

export default ControlledAssessmentSelector;
